/**
 * Globals that scripts probe to learn who is watching (docs/event-model.md
 * §5): analytics and session recording, security and monitoring tools, and
 * crypto wallets. Probing several is a classic "stay quiet if observed" or
 * "find something to steal" move. Names are top-level `window` properties.
 */
export const WATCHED_GLOBALS = {
  analytics: [
    "ga",
    "gtag",
    "_gaq",
    "dataLayer",
    "google_tag_manager",
    "_paq",
    "fbq",
    "_fbq",
    "hj",
    "_hjSettings",
    "mixpanel",
    "amplitude",
    "heap",
    "analytics",
    "FS",
    "_fs_namespace",
    "clarity",
    "posthog",
    "Intercom",
    "_satellite",
    "optimizely",
    "_kmq",
    "snowplow",
    "plausible",
    "umami",
    "ym",
    "ttq",
    "twq",
    "pintrk",
    "_linkedin_partner_id",
  ],
  security: [
    "grecaptcha",
    "hcaptcha",
    "turnstile",
    "_cf_chl_opt",
    "_pxAppId",
    "bmak",
    "ddjskey",
    "Sentry",
    "__SENTRY__",
    "Raven",
    "newrelic",
    "NREUM",
    "DD_RUM",
    "LogRocket",
    "Bugsnag",
    "TrackJS",
  ],
  wallet: [
    "ethereum",
    "web3",
    "solana",
    "phantom",
    "BinanceChain",
    "tronWeb",
    "tronLink",
    "coinbaseWalletExtension",
    "keplr",
    "okxwallet",
    "trustwallet",
    "xfi",
    "unisat",
    "bitkeep",
    "martian",
    "aptos",
    "petra",
    "suiWallet",
  ],
} as const satisfies Record<string, readonly string[]>;

export type WatcherFamily = keyof typeof WATCHED_GLOBALS;

/** The family a global name belongs to, if any. */
export function watcherFamily(name: string): WatcherFamily | null {
  for (const [family, names] of Object.entries(WATCHED_GLOBALS)) {
    if ((names as readonly string[]).includes(name)) return family as WatcherFamily;
  }
  return null;
}
